import { paths } from '@app/routes/paths';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth';

interface PublicOnlyRouteProps {
  children: ReactNode;
  redirectTo?: string | undefined;
}

// Root resolves to the role-aware home via the index redirect.
export function PublicOnlyRoute({ children, redirectTo = paths.root }: PublicOnlyRouteProps) {
  const { isAuthenticated, status } = useAuth();

  if (status === 'idle' || status === 'booting') {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
